[{
        "title": "Client Onboarding and Status Disclosure",
        "headerTitle": "Placement Gallagher Excellence Model - Client Onboarding and Status Disclosure",
        "description": "Pre-placement activities and placement planning",
        "route": "client-onboarding-and-status-disclosure"        
    },
    {
        "title": "Client Due Diligence",
        "headerTitle": "Placement Gallagher Excellence Model - Client Due Diligence",
        "description": "Know Your Client and New Client requirements and Sanctions",
        "route": "client-due-diligence"
    },
    {
        "title": "Marketing Approval and Data Gathering",
        "headerTitle": "Placement Gallagher Excellence Model - Marketing Approval and Data Gathering",
        "description": "Identifying Markets, Data Gathering, Submission Preparation",
        "route": "marketing-approval-and-data-gathering"
    },
    {
        "title": "Obtain Quotations from Reinsurers",
        "headerTitle": "Placement Gallagher Excellence Model - Obtain Quotations from Reinsurers",
        "description": "Securing and Managing Market Quote",
        "route": "obtain-quotations-from-reinsurers"
    },
    {
        "title": "Client Receives Quotation",
        "headerTitle": "Placement Gallagher Excellence Model - Client Receives Quotation",
        "description": "Quote Presentation to Client",
        "route": "client-receives-quotation"
    },
    {
        "title": "Client Confirms Firm Order",
        "headerTitle": "Placement Gallagher Excellence Model - Client Confirms Firm Order",
        "description": "Firm Order Review and Client Instruction",
        "route": "client-confirms-firm-order"
    },
    {
        "title": "Placement Status Update and Completion",
        "headerTitle": "Placement Gallagher Excellence Model - Placement Status Update and Completion",
        "description": "Authorizations, Suggested Final Lines, Placement Subscription Status",
        "route": "placement-status-update-and-completion"
    },
    {
        "title": "Client Receives Contract Documentation",
        "headerTitle": "Placement Gallagher Excellence Model - Client Receives Contract Documentation",
        "description": "Placement Completion and Final Contract Documentation",
        "route": "client-receives-contract-documentation"
    }
]